import React from 'react'
import ContactUs from './ContactUs'
import Footer from './Footer'
import Navbar from './Navbar'

const Contact = () => {
  return (
    <div>
        {/* <Navbar /> */}
      <ContactUs />
      {/* <Footer /> */}
    </div>
  )
}

export default Contact
